var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-cog fa-lg icn-colour"})])])
}]

export { render, staticRenderFns }